import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Alert,
  Box,
  Typography,
} from "@mui/material"; // For loading/error

// API Functions
import { getServices } from "../api/serviceApi"; // Use Service API

// Components
import "../assets/styles/Products.css"; // Reuse styles if applicable
import ServiceCard from "../components/ServiceCard";
// Removed: import useStore from "../context/store";

function Services() {
  const [selectedSector, setSelectedSector] = useState(null);
  const [services, setServices] = useState([]); // State for services
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sectors, setSectors] = useState([]);
  const [bgImage] = useState(
    "https://pa-ats.com/wp-content/uploads/sites/38/2021/12/Start-Process.jpg"
  ); // Default BG
  const [heading] = useState("Services"); // Default Heading

  useEffect(() => {
    const fetchServicesData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getServices(); // Use Service API
        const fetchedServices = response.data;
        setServices(fetchedServices);

        // Dynamically extract unique sectors
        const uniqueSectors = [
          ...new Set(fetchedServices.map((service) => service.sector)),
        ];
        setSectors(uniqueSectors);

        // Set BG/Heading (similar logic as Products page)
        if (fetchedServices.length > 0) {
          // setBgImage(fetchedServices[0].someCommonBgField || defaultBgImage);
          // setHeading('Our Services');
        }
      } catch (err) {
        console.error("Fetch Services Error:", err);
        setError(err.response?.data?.message || "Failed to fetch services.");
        setServices([]);
        setSectors([]);
      } finally {
        setLoading(false);
      }
    };

    fetchServicesData();
  }, []); // Fetch only once on mount

  const handleFilterClick = (sector) => {
    setSelectedSector(sector === selectedSector ? null : sector);
  };

  // Filter services based on selected sector
  const filteredServices = selectedSector
    ? services.filter((service) => service.sector === selectedSector)
    : services;

  return (
    <div>
      {/* --- Banner Section --- */}
      <div
        style={{ backgroundImage: `url(${bgImage})` }}
        className="bg-cover bg-center background-no-repeat background-blend-multiply pt-24 md:pt-48 pb-14 md:pb-28 px-4 md:px-0"
      >
        <div className="max-w-[1400px] mx-auto flex h-full flex-col">
          <div className="products-page py-10 md:py-0">
            <h1 className="text-white md:text-8xl text-4xl text-left font-medium capitalize">
              {heading}
              {selectedSector && ` - ${selectedSector}`}
            </h1>
          </div>
          {!loading &&
            sectors.length > 0 && ( // Only show filters if sectors are loaded
              <div className="filters text-left space-y-5 md:mt-24">
                <h2 className="text-white text-2xl">Category</h2>
                <div className="sector-buttons max-w-3xl flex flex-wrap gap-3">
                  {sectors.map((sector) => (
                    <button
                      key={sector}
                      onClick={() => handleFilterClick(sector)}
                      className={`px-4 py-2 capitalize ${
                        selectedSector === sector
                          ? "bg-[#f66629] border-0 text-white"
                          : "bg-[#cc673d] border-0 text-white"
                      }`}
                    >
                      {sector}
                    </button>
                  ))}
                  {selectedSector && (
                    <button
                      onClick={() => handleFilterClick(null)}
                      className="px-4 py-2 bg-red-500 border-0 text-white"
                    >
                      Clear Filter
                    </button>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>

      {/* --- Service List Section --- */}
      <div className="product-list max-w-[1400px] mx-auto text-left px-4 md:px-0">
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Alert severity="error" sx={{ my: 4 }}>
            {error}
          </Alert>
        )}
        {!loading && !error && (
          <>
            <h2 className="text-2xl font-medium py-10">
              {selectedSector ? `${selectedSector} Services` : "All Services"} (
              {filteredServices.length})
            </h2>
            {filteredServices.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 pb-28">
                {filteredServices.map((service) => (
                  <ServiceCard
                    key={service._id} // Use MongoDB _id
                    imageUrl={service.imageUrl}
                    title={service.title}
                    buttonText="More Details"
                    link={`/services/${service._id}`} // Use MongoDB _id
                  />
                ))}
              </div>
            ) : (
              <Typography sx={{ py: 10, textAlign: "center" }}>
                No services found{" "}
                {selectedSector ? `in the ${selectedSector} category` : ""}.
              </Typography>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Services;
